/* @flow */
import * as React from 'react';

const ArrowIndigoLeft = props => (
  <svg width={16} height={11} viewBox="0 0 16 11" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      fillRule="evenodd"
      d="M15.5,5 L1.762,5 L6.165,0.864 C6.366,0.675 6.376,0.359 6.187,0.157 C6.088,0.053 5.955,0 5.822,0 C5.699,0 5.576,0.045 5.48,0.136 L0.157,5.135 C0.117,5.176 0.11,5.2 0.096,5.22 C0.068,5.263 0.05,5.281 0.041,5.302 C0.025,5.346 0.023,5.376 0.018,5.407 C0.012,5.436 0.002,5.463 0.001,5.493 C0.002,5.537 0.012,5.564 0.018,5.593 C0.024,5.624 0.025,5.654 0.037,5.683 C0.05,5.719 0.069,5.736 0.081,5.757 C0.11,5.801 0.117,5.824 0.135,5.842 C0.154,5.86 5.479,10.864 5.479,10.864 C5.68,11.053 5.996,11.043 6.186,10.842 C6.375,10.641 6.365,10.325 6.164,10.135 L1.762,6 L15.5,6 C15.776,6 16,5.776 16,5.5 C16,5.224 15.776,5 15.5,5 Z"
    />
  </svg>
);

export default ArrowIndigoLeft;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-indigo-left.js